// extracted by mini-css-extract-plugin
export default {"wwdTilesSection":"WhatWeDo_wwdTilesSection__Ud2XC","wwdTilesDivider":"WhatWeDo_wwdTilesDivider__PB-St","wwdContentBanner":"WhatWeDo_wwdContentBanner__iKl44"};